import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';

import store from '../../redux/store';
import { actions } from "../../redux/actions";

import './Sidebar.scss';

const menusAssessor = [
    { name: 'Dashboard', redirectTo: '/home', imgname: "dashboard", includes: "home" },
    { name: 'Assessments', redirectTo: '/assessments', imgname: "folder",includes: "assessments",
     submenu: [
        // {
        //     name: 'Grade',
        //     includes:'Grade',
        //     imgname: "grade",
        //     redirectTo: '/assessments/grade',
        // },
        { name: 'Analytics', redirectTo: '/assessments/analytics', imgname: "graph",includes: "Analytics", },
   
    ]},
    { name: 'Scheduler', redirectTo: '/scheduler', imgname: "runassessment",includes: "scheduler", },
    // { name: 'Users', redirectTo: '/users', imgname: "employee" },
    { name: 'Locations', redirectTo: '/locations', imgname: "loc", includes: "locations" },
    // { name: 'Messages', redirectTo: '/messages', imgname: "msg",includes: "messages", },
    { name: 'Settings', redirectTo: '/settings/users', imgname: "setting", includes: "settings",
    submenu: [
        {
            name: 'Users',
            includes:'Users',
            imgname: "setting",
            redirectTo: '/settings/users',
        }, 
        {
            name: 'Departments',
            includes:'departments',
            imgname: "setting",
            redirectTo:  '/settings/departments',
        }, 
        {
            name: 'Programme',
            includes:'programme',
            imgname: "setting",
            redirectTo: '/settings/programmes'
        }, 
        {
            name: 'Subjects',
            includes:'subject',
            imgname: "setting",
            redirectTo: '/settings/subjects'
        }, 
        // {
        //     name: 'Master Profile',
        //     includes:'masterprofile',
        //     imgname: "setting",
        //     redirectTo: '/settings/masterprofile'
        // }, 
    ]

},
    { name: 'Assignments', redirectTo: '/assignments', imgname: "folder", includes: "assignments" },

   
];
const menusAssesse = [
    { name: 'Dashboard', redirectTo: '/home', imgname: "dashboard", includes: "home" },
    { name: 'Assessments', redirectTo: '/take-assessments', imgname: "folder", includes: "assessments" },
    { name: 'My Assignments', redirectTo: '/assignments', imgname: "folder", includes: "assignments" },
    // { name: 'Messages', redirectTo: '/messages', imgname: "msg" },
    // { name: 'Settings', redirectTo: '/settings', imgname: "setting" },
];

export default function Sidebar(props) {

    const dispatch = useDispatch();

    const loggedInUserData = useSelector((state) => { return state.user });
    const sideBarData = useSelector((state) => state.sidebar);
    const resizeData = useSelector((state) => state.resize );
 
    const [ menus, setmenus] = useState(loggedInUserData?.rolename == "Assesse" ? menusAssesse : menusAssessor);

    useEffect(() => {
        menus.forEach(element => {
            if (Array.isArray(element.submenu) && element.submenu.length > 0) {
                if (props.location.pathname.includes(element.redirectTo)) {
                    element.openSubMenu = true;
                } else {
                    element.openSubMenu = element.submenu.filter(elem => { return props.location.pathname.includes(elem.redirectTo); }).length > 0 ? true : false
                }
            }
        });
        setmenus(menus)
        return () => {
        }
    }, []);

    const handleOpenSideMenu = (menuIndex) => {
        const menulist = [...menus];
        menulist.forEach((element, index) => {
            if (Array.isArray(element.submenu) && element.submenu.length > 0) {
                element.openSubMenu = menuIndex == index ? true : false;
            }
        });

        setmenus(menulist)
    };

    return (
        <div className={`sidebar-box ${sideBarData.isOpen ? 'd-flex' : 'd-none'} d-lg-flex`} onClick={() => { dispatch(actions.setSideBar(false)); }}> 
            <div className="sidebar-content">
                <ul className="side-menu-container w-100">
                    {
                        menus.map((menu, index) =>
                        <>
                            <li key={`menu_${index}`} className={`menu ${props.location.pathname.includes(menu.includes) ? 'active-menu ' : ''}`} onClick={() => handleOpenSideMenu(index)}>
                                <Link to={menu.redirectTo} onClick={() => {
                                    store.dispatch(actions.setScreenName(menu.name));
                                    if (resizeData.windowInnerWidth < 992) {
                                        dispatch(actions.setSideBar(false));
                                    }
                                }}>
                                    <div className="d-flex  align-items-center">
                                        <img className=" mx-2" width={"15px"} src={`${process.env.PUBLIC_URL}/static/images/${menu.imgname}${props.location.pathname.includes(menu.includes) ? "w" : "g"}.png`} alt={menu.name} />
                                        <div className={`menu-title`} style={{ color: props.location.pathname.includes(menu.includes) ? "#FFF" : "#585f69" }}>{menu.name}</div>
                                    </div>
                                    {Array.isArray(menu.submenu) && menu.submenu.length > 0 ? <i className={`fa fa-chevron-${props.location.pathname.includes(menu.includes) ? 'down' : 'right'}`}></i> : ''}
                                </Link>
                            
                            </li>
                            
                                {
                                props.location.pathname.includes(menu.includes) && menu.submenu?.map((subMenu, subMenuIndex) =>
                                        <>
                                            <li  className={` ${props.location.pathname.includes(subMenu.redirectTo) ? 'sub-menu-active-menu ' : 'sub-menu'}`}>
                                                <Link to={subMenu.redirectTo}   onClick={() => {
                                                if (resizeData.windowInnerWidth < 992) {
                                                    dispatch(actions.setSideBar(false));
                                                }
                                            }}>
                                                    <div key={`submenu_${index}_${subMenuIndex}`} className={`align-items-center`} style={{marginLeft: '30px',}} >
                                                    <img className=" me-2" width={"15px"} src={`${process.env.PUBLIC_URL}/static/images/${subMenu.imgname}${props.location.pathname.includes(subMenu.redirectTo) ? "w" : "g"}.png`} alt={subMenu.name} />
                                                        {subMenu.name}
                                                    </div>
                                                </Link>
                                            </li>
                                        </>
                                    )
                                }
                            
                        </>
                        )
                    }
                </ul>

                <div className="d-flex align-items-center justify-content-center">
                    <img className="w-80 align-self-center" src={`${process.env.PUBLIC_URL}/static/images/adspace.jpg`} alt="ad" />
                </div>
            </div>
        </div>
    )
}
